import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { NewClaimRoutingModule } from './new-claim-routing.module'
import { NewClaimComponent } from './new-claim.component'
import { HeaderComponent } from '@components/header/header.component'
import { ProgressBarComponent } from '@components/progress-bar/progress-bar.component'


@NgModule({
  declarations: [
    NewClaimComponent
  ],
    imports: [
        CommonModule,
        NewClaimRoutingModule,
        HeaderComponent,
        ProgressBarComponent
    ]
})
export class NewClaimModule { }
